import { Button, Form, Input, Space, Spin } from "antd";
import { PlusOutlined, SettingOutlined } from '@ant-design/icons';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import useLevels from "../../hooks/useLevels";
import { useState, useEffect } from "react";
import { PageHeader } from "@ant-design/pro-components";
import styles from './Settings.module.css';
import LevelItem from "../../Components/LevelItem/LevelItem";
import api from "../../api/api";
import { useSelector } from "react-redux";
const formItemLayout = {
  labelCol: {
    xs: { span: 3 },
    sm: { span: 3 },
  },
  wrapperCol: {
    xs: { span: 3 },
    sm: { span: 12 },
  },
};

const Settings = () => {
  const [form] = Form.useForm();
  const { levels, loading: getLevelsLoading } = useLevels();
  const [items, setItems] = useState([]);
  const [newItemName, setNewItemName] = useState('');
  const token = useSelector((state) => state.token);
  const AuthHeader = { Authorization: "Token " + token };
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setItems(levels);
  }, [levels]);

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const reorderedItems = Array.from(items);
    const oldItmes = Array.from(items)
    const [movedItem] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, movedItem);
    setItems(reorderedItems);
    const obj = {};
    reorderedItems.forEach((itm , index)=>{
      obj[`${itm.value}`] = index + 1;
    })
    api.post('/reorder-level' , obj, {headers : AuthHeader}).catch(()=>{
      setItems(oldItmes)
    })

  };

  const handleAddItem = () => {

    setLoading(true)
    api.post('/levels', { name: newItemName, order: items.length + 1 }, { headers: AuthHeader })
      .then((res) => {
        const newItem = res.data;
        setItems([...items, {
          value: newItem.id,
          text: newItem.name,
          order: newItem.order
        }]);
        setNewItemName('');
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  };

  const handleRemoveItem = (id, removeLoading) => {

    api.delete('/level/' + id, { headers: AuthHeader })
      .then((res) => {
        removeLoading()
        setItems(items.filter(item => item.value !== id));

      })
      .catch(() => {
        removeLoading()

      })
  };

  const handleSaveItem = (id, newText, onSuccess, removeLoading) => {
    api.patch('/level/' + id, {name : newText} ,{ headers: AuthHeader })
      .then((res) => {
        removeLoading()
        onSuccess()
      })
      .catch(() => {
        removeLoading()

      })
  };

  return (
    <div>
      <PageHeader
        className="site-page-header"
        title="تنظیمات"
        extra={<Space></Space>}
        avatar={{ icon: <SettingOutlined /> }}
      />
      <div className={styles.LevelsSettings}>
        <PageHeader title="تنظیمات سطح زبان آموز" />
        <Form
          {...formItemLayout}
          form={form}
          name="register"
          onFinish={() => { }}
          scrollToFirstError
        >
          <Form.Item >
            <div className={styles.AddNewLevel}>
              <Input
                value={newItemName}
                onChange={(e) => setNewItemName(e.target.value)}
                placeholder="سطح زبان جدید"
                disabled={getLevelsLoading}
              />
              <Button disabled={getLevelsLoading || `${newItemName}`.trim().length === 0} loading={loading} type="primary" onClick={handleAddItem}><PlusOutlined className={styles.Icon} />اضافه کردن </Button>
            </div>
          </Form.Item>
          {getLevelsLoading ? <div className={styles.Loading}>
            <Spin />
            در حال دریافت اطلاعات ...
          </div> : <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="droppable">
              {(provided) => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                  {items.map((item, index) => (
                    <Draggable key={item.value} draggableId={String(item.value)} index={index}>
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}

                        >
                          <LevelItem order={index + 1} text={item.text}
                            onSave={(newText, onSuccess, removeLoading) => { handleSaveItem(item.value, newText, onSuccess, removeLoading) }}
                            onDelete={(removeLoading) => handleRemoveItem(item.value, removeLoading)} />

                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>}
        </Form>
      </div>
    </div>
  );
};

export default Settings;